"use strict";
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.presentationReady) return;
      gallery.dataset.presentationReady = 'true';
      gallery.querySelectorAll('[data-gallery-thumb][data-photo-number]').forEach(thumb => {
        thumb.addEventListener('click', () => {
          const image = gallery.querySelector('.gallery-main img');
          if (!image) return;
          image.width = Number(thumb.dataset.imageWidth);
          image.height = Number(thumb.dataset.imageHeight);
          image.srcset = `${thumb.dataset.small} ${thumb.dataset.smallWidth}w, ${thumb.dataset.src} ${thumb.dataset.width}w`;
          const counter = gallery.querySelector('[data-current-photo]');
          if (counter) counter.textContent = thumb.dataset.photoNumber;
        });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
